export default __webpack_public_path__ + "static/blogBG3-mobile-a0a7042a1f32db79da1f3cd5070a91b4.svg";